import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../DefaultButton';

const AcceptCookieButton = ({ handlerClick }) => {
	const { t } = useTranslation();
	return (
		<Button
			content={t('legalWarning.cookies.accept')}
			variant={'contained'}
			color={'primary'}
			onClick={handlerClick}
		/>
	);
};

export default AcceptCookieButton;
